const getters = {
  wx_flock_id: state => state.weixin.wx_flock_id,
  auth_list: state => state.weixin.auth_list,
  page_index: state => state.base.page_index,
  store_info: state => state.base.store_info
}
export default getters
